import { BUTTON_THEMES } from "../enumerators/button";

export const BUTTON_THEME_DEFAULT = BUTTON_THEMES.DARK;
